import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ConfirmationModal = ({ show, message, onConfirm, onCancel }) => {
    if (!show) {
        return null;
    }

    return (
        <div style={styles.overlay}>
            <div style={styles.modalBox}>
                <div style={styles.iconContainer}>
                    <AlertTriangle size={48} color="#e7c651" />
                </div>
                <h3 style={styles.title}>Confirmação Necessária</h3>
                <p style={styles.message}>{message}</p>
                <div style={styles.buttonContainer}>
                    <button onClick={onCancel} style={{ ...styles.button, ...styles.cancelButton }}>
                        Cancelar
                    </button>
                    <button onClick={onConfirm} style={{ ...styles.button, ...styles.confirmButton }}>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
};

// --- Estilos para o Modal de Confirmação ---
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000, // Z-index maior que o do alerta
        padding: '20px',
    },
    modalBox: {
        backgroundColor: '#1a1a2e',
        padding: '24px',
        borderRadius: '12px',
        color: '#f0f0f0',
        width: '100%',
        maxWidth: '320px',
        boxShadow: '0 5px 25px rgba(0, 0, 0, 0.5)',
        border: '1px solid #4a4a6e',
        textAlign: 'center',
        animation: 'slideIn 0.3s ease-out forwards', // Reutiliza a animação do CustomAlert
    },
    iconContainer: {
        marginBottom: '16px',
    },
    title: {
        margin: '0 0 8px 0',
        fontSize: '18px',
        fontWeight: '600',
    },
    message: {
        margin: '0 0 24px 0',
        fontSize: '15px',
        lineHeight: '1.5',
        color: '#a0a0b0',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '12px',
    },
    button: {
        flex: 1,
        padding: '12px',
        borderRadius: '8px',
        border: 'none',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s, transform 0.2s',
    },
    cancelButton: {
        backgroundColor: '#3a3a5e',
        color: '#c0c0ff',
    },
    confirmButton: {
        backgroundColor: '#6a0dad',
        color: '#ffffff',
    }
};

export default ConfirmationModal;